import fetch from '@qnpm/react-native-ext-fetch';
import { action, observable } from 'mobx';
import URLS from '../Constant/urls';
import { QLoginManager, DeviceInfo } from 'qunar-react-native';
// import { AsyncStorage } from 'react-native';
import { RootStoreInterface } from './index';
import getClientJson from "../Utils/getClientJson";

const { isNotRn } = DeviceInfo;

export interface GuideWeChatStoreInterface {
    rootStore: RootStoreInterface;
    topBannerData: object;
    topBannerType: string;
    toggleShowGuideChat(statusFilter: string): void;
    orderPopup:any;
    orderPopupVisible:boolean;
    onCancelWxPopup(flag: boolean): void;
}

export default class GuideWeChatStore {
    @observable
    public topBannerData = {};

    @observable
    public orderPopup = {};
    @observable
    public orderPopupVisible = false;

    @observable
    public topBannerType = 'hide';

    public rootStore: RootStoreInterface;

    public constructor(rootStore: RootStoreInterface) {
        this.rootStore = rootStore;
        this.uiState = this.rootStore.uiState;
    }

    @action
    public onCancelWxPopup = (flag:boolean) => {
        this.orderPopupVisible = flag;
    }

    @action
    public toggleShowGuideChat = (statusFilter: string) => {
        // 非rn 不展示
        if (isNotRn) return;
        //订单状态不是all 或者 不是当前页面 不发送请求-不展示机酒/微信入口
        // 筛选业务线businessTypes是否漏出 由后端控制
        if (statusFilter !== 'all' || !this.uiState.isInCurrentPage) {
            this.topBannerData = {};
            this.orderPopup = {};
            return;
        }
        // 在此调接口
        this.getBannerData();
    };

    @action
    public getBannerData = () => {
        QLoginManager.getLoginInfo(
            async (userData: any) => {
                if (userData.userIsValid === '0' || !userData.userID || userData.userID.length === 0){
                    return;
                }
                const commonParam = await getClientJson(this.rootStore.hyId || 'cmn_order_rn');
                const param = {
                    commonParam,
                    uuid: userData.userUserID,
                    scene: 'order',
                    businessTypes: this.uiState.businessValue,
                    source:this.uiState.sourceFrom,
                    popupVersion: '1.0',
                    version:'1.0'
                }
                fetch({
                    url: URLS.recommend,
                    method: 'POST',
                    body: param
                })
                .then((response: any) => {
                    // console.log('----recommend----',JSON.stringify(response))
                    // response = recommend_mock;
                    if (response.status === 0 ) {
                       const data = response.data || {};
                       this.topBannerType = data.type || 'hide'; //qmember, jijiuBanner, wechat hide
                       this.topBannerData = data[data.type] || {};
                       if(this.uiState.isInCurrentPage){//当前页面才弹窗
                            this.orderPopup = data.orderPopup || {};// 微信公众号弹窗
                            this.orderPopupVisible = this.orderPopup.show || false;
                       }
                    } else {
                        this.topBannerData = {};
                    }
                })
                .catch((error: any) => {
                    this.topBannerData = {};
                });
            },
            (error: any) => {
                // this.topBannerData = {};
            }
        );
    }
}




